import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

const STATUS_MAP = {
  0: "Default", 1: "Booked", 2: "Cancelled", 3: "Reschedule",
  4: "Pending", 5: "Fail", 6: "Cancelled Booking List",
  7: "Cancel Under Process", 8: "Partial Cancel", 9: "Refund",
  10: "Payment Pending", 11: "Reschedule Under Process", 12: "Rejected",
  13: "InProgress", 14: "Refund Under Process", 15: "No Action",
  16: "Partial Reschedule", 17: "Hold", 18: "Hold Under Process",
  19: "Reject Onward", 20: "Reject Return", 21: "Ticket Pending",
  22: "Ticket Released",
};

const fmtDate = (d) => {
  if (!d) return "-";
  const parsed = new Date(d);
  if (!isNaN(parsed)) return parsed.toLocaleDateString("en-IN", { weekday: "long", day: "2-digit", month: "long", year: "numeric" });
  return d;
};

const fmtTime = (d) => {
  if (!d) return "-";
  if (d.includes("T")) {
    const timePart = d.split("T")[1];
    const t = new Date(`1970-01-01T${timePart}`);
    return isNaN(t) ? timePart : t.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: true });
  }
  return d;
};

export default function Tickets() {
  const navigate = useNavigate();
  const location = useLocation();

  // Plain INR formatting — no currency conversion, no external API call.
  const aed = (n) => {
    if (n == null) return "-";
    return `₹${Number(n).toLocaleString("en-IN")}`;
  };

  const { bookingData, bookingId, txnId } = location.state || {};
 
  console.log("📥 data:", { bookingData, bookingId, txnId });

  if (!bookingData) {
    return (
      <div style={S.page}>
        <div style={S.noDataBox}>
          <div style={{ fontSize: 40 }}>⚠️</div>
          <h2 style={S.h2}>No booking data found</h2>
          <p style={S.muted}>Please complete booking first.</p>
          <button style={S.btnBlue} onClick={() => navigate("/")}>Go Home</button>
        </div>
      </div>
    );
  }

  const contracts   = bookingData.Contracts || [];
  const passengers  = bookingData.Flightpassenger || [];
  const contract0   = contracts[0] || {};
  const segments    = contracts.flatMap((c) => c.AirSegments || []);
  const seg0        = segments[0] || {};
  const fare0       = contract0.AirlineFare || {};
  const isRound     = contracts.length === 2;

  const bookingStatus = bookingData.BookingStatus ?? bookingData.Status;
  const statusLabel   = STATUS_MAP[bookingStatus] ?? `Status ${bookingStatus}`;
  const pnr           = bookingData.AirlinePnr || contract0.GDSPnr || seg0.PNR || "-";
  const bookingDateDisplay = bookingData.BookingDate
    ? new Date(bookingData.BookingDate).toLocaleDateString("en-IN", { weekday: "long", day: "numeric", month: "long", year: "numeric" })
    : new Date().toLocaleDateString("en-IN", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
  let totalBaseFare = 0, totalTax = 0, totalServiceCharge = 0, totalDiscount = 0;
  let totalGross = 0, totalNet = 0;

  if (isRound) {
    contracts.forEach((c) => {
      const f = c.AirlineFare || {};
      totalBaseFare      += Number(f.BaseFare)       || 0;
      totalTax            += Number(f.TaxFare)        || 0;
      totalServiceCharge  += Number(f.ServiceCharge)  || 0;
      totalDiscount        += Number(f.Discount)       || 0;
      totalGross           += Number(f.GrossFare)      || 0;
      totalNet              += Number(f.NetFare)        || 0;
    });
  } else {
    totalBaseFare       = Number(fare0.BaseFare)       || 0;
    totalTax             = Number(fare0.TaxFare)        || 0;
    totalServiceCharge   = Number(fare0.ServiceCharge)  || 0;
    totalDiscount         = Number(fare0.Discount)       || 0;
    totalGross            = Number(contracts[0]?.AirlineFare?.GrossFare) || 0;
    totalNet               = Number(fare0.NetFare)        || 0;
  }

  const otherCharges = totalTax + totalServiceCharge;
const totalMeal    = Number(fare0.PriceMeal)    || 0;
const totalBaggage = Number(fare0.PriceBaggage) || 0;
const totalSeat    = Number(fare0.PriceSeat)    || 0;

const grandTotal =
  totalBaseFare +
  totalTax +
  totalServiceCharge +
  totalMeal +
  totalBaggage +
  totalSeat -
  totalDiscount;
  return (
    <div style={S.page} className="ticket-page">
      <div style={S.printable} className="ticket-printable">
        <table style={S.outerTable}>
          <tbody>
            <tr>
              <td style={{ padding: "16px 20px 0" }}>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <tbody>
                    <tr>
                      <td style={{ width: "20%", verticalAlign: "middle" }}>
                        <img
                          src="/tripcaliber-logo.png"
                          alt="TripCaliber Logo"
                          style={{ width: 160 }}
                        />
                      </td>
                      <td style={{ textAlign: "right", fontSize: 11, color: "#333", verticalAlign: "middle" }}>
                        <strong style={{ fontSize: 18 }}>TripCaliber</strong>
                        <p style={{ margin: "5px 0", fontSize: 11 }}>
                          <strong>Booking Date:</strong> {bookingDateDisplay}
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={2}>
                        <hr style={{ borderColor: "#d1d1d1", margin: "10px 0" }} />
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: 11, color: "#333" }}>
                        <strong>Your e-Ticket</strong>
                      </td>
                      <td style={{ textAlign: "right", fontSize: 11, color: "#333" }}>
                        <strong>Booking Date:</strong> {bookingDateDisplay}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            
            <tr>
              <td style={{ padding: "16px 20px" }}>
                <table style={{ width: "100%", fontSize: 12, borderCollapse: "collapse" }}>
                  <tbody>
                    <tr>
                      <td style={{ width: "50%", verticalAlign: "top" }}>
                        <table cellPadding={3}>
                          <tbody>
                            <tr>
                              <td style={{ width: 120 }}><strong>Reference ID</strong></td>
                              <td>{bookingData.BookingId || bookingId}</td>
                            </tr>
                            <tr>
                              <td><strong>Ticket Status</strong></td>
                              <td>
                                <span style={{
                                  ...S.statusBadge,
                                  ...(bookingStatus === 1 || bookingStatus === 22 ? S.badgeGreen
                                    : bookingStatus === 2 || bookingStatus === 5 ? S.badgeRed
                                    : S.badgeYellow)
                                }}>
                                  {statusLabel}
                                </span>
                              </td>
                            </tr>
                            {txnId && (
                              <tr>
                                <td><strong>Transaction ID</strong></td>
                                <td>{txnId}</td>
                              </tr>
                            )}
                            {pnr && pnr !== "-" && (
                              <tr>
                                <td><strong>PNR</strong></td>
                                <td><strong style={{ letterSpacing: 2 }}>{pnr}</strong></td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </td>
                      <td style={{ width: "50%", textAlign: "right", verticalAlign: "middle" }}>
                        <div style={S.barcodeBox}>
                          <div style={S.barcodeLines}>
                            {Array.from({ length: 30 }).map((_, i) => (
                              <div key={i} style={{ ...S.barcodeLine, width: i % 3 === 0 ? 3 : 1.5 }} />
                            ))}
                          </div>
                          <div style={{ fontSize: 10, color: "#555", marginTop: 4, letterSpacing: 2 }}>
                            {bookingData.BookingId || bookingId}
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>

            {/* ══════════════ FLIGHT SEGMENTS TABLE ══════════════ */}
            <tr>
              <td style={{ padding: "0 20px 16px" }}>
                <hr style={{ borderStyle: "dashed", borderColor: "#ccc", margin: "8px 0 16px" }} />

                <table style={{ ...S.dataTable, width: "100%" }}>
                  <thead>
                    <tr>
                      {["Airline/Flight No.", "Departure", "Arrival", "Class", "PNR", "Terminal Info"].map((h) => (
                        <th key={h} style={S.th}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {segments.length > 0 ? segments.map((seg, i) => (
                      <tr key={i}>
                        <td style={S.td}>
                          <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                            <div style={S.airlineCircle}>
                              {seg.AirlineCode ? (
                                <img
                                  src={`./Flight_Images/${seg.AirlineCode}.gif`}
                                  alt={seg.AirlineName || seg.AirlineCode}
                                  style={S.airlineLogo}
                                  onError={(e) => {
                                    e.target.style.display = "none";
                                    if (e.target.nextSibling) {
                                      e.target.nextSibling.style.display = "flex";
                                    }
                                  }}
                                />
                              ) : null}
                              <span
                                style={{
                                  ...S.airlineFallback,
                                  display: seg.AirlineCode ? "none" : "flex",
                                }}
                              >
                                ✈
                              </span>
                            </div>
                            <div>
                              <div style={{ fontWeight: 600, fontSize: 12 }}>{seg.AirlineName || "-"}</div>
                              <div style={{ fontSize: 11, color: "#777" }}>
                                {seg.AirlineCode}-{seg.FlightNumber}
                              </div>
                            </div>
                          </div>
                        </td>
                        <td style={S.td}>
                          <span style={S.airportCode}>[{seg.Origen || seg.DepartureAirportCode || "-"}]</span>
                          <br />
                          <span style={{ fontSize: 11 }}>{seg.DepartureDateTime || "-"}</span>
                          {seg.DepartureTime && <span style={{ fontSize: 11 }}> {seg.DepartureTime}</span>}
                        </td>
                        <td style={S.td}>
                          <span style={S.airportCode}>[{seg.Destination || seg.ArrivalAirportCode || "-"}]</span>
                          <br />
                          <span style={{ fontSize: 11 }}>{seg.ArrivalDateTime || "-"}</span>
                          {seg.ArrivalTime && <span style={{ fontSize: 11 }}> {seg.ArrivalTime}</span>}
                        </td>
                        <td style={S.td}>{seg.SeatClass || "Economy"}</td>
                        <td style={S.td}>
                          <strong style={{ letterSpacing: 1 }}>
                            {pnr !== "-" ? pnr : (seg.PNR || contract0.GDSPnr || "-")}
                          </strong>
                        </td>
                        <td style={S.td}>{seg.OriginAirportTerminal || seg.DepartureTerminal || "-"}</td>
                      </tr>
                    )) : (
                      <tr>
                        <td colSpan={6} style={{ ...S.td, textAlign: "center", color: "#999" }}>
                          No flight segments found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </td>
            </tr>

            <tr>
              <td style={{ padding: "0 20px 16px" }}>
                <strong style={{ color: "#1f91cd", fontSize: 15 }}>Passenger - Details</strong>

                <table style={{ ...S.dataTable, width: "100%", marginTop: 8 }}>
                  <thead>
                    <tr>
                      {["Passenger Name", "Ticket No.", "bag[Cabin]", "bag[CheckIn]", "Meal", "Baggage", "Seat", "Refundable", "Status"].map((h) => (
                        <th key={h} style={S.th}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {passengers.length > 0 ? passengers.map((pax, i) => (
                      <tr key={i}>
                        <td style={S.td}>
                          <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                            <div style={S.avatar}>{pax.FirstName?.[0]?.toUpperCase() || "P"}</div>
                            {pax.Title} {pax.FirstName} {pax.LastName}
                          </div>
                        </td>
                        <td style={S.td}>{pax.TicketNumber || pax.TicketNo || "-"}</td>
                        <td style={S.td}>{seg0.BaggageAllowed?.HandBaggage || "-"}</td>
                        <td style={S.td}>{seg0.BaggageAllowed?.CheckInBaggage || "-"}</td>
                        <td style={S.td}>{pax.MealCode || "-"}</td>
                        <td style={S.td}>{pax.BaggageCode || "-"}</td>
                        <td style={S.td}>{pax.SeatCode || "-"}</td>
                        <td style={S.td}>{contract0.Refundable != null ? String(contract0.Refundable) : "-"}</td>
                        <td style={S.td}>{statusLabel}</td>
                      </tr>
                    )) : (
                      <tr>
                        <td colSpan={9} style={{ ...S.td, textAlign: "center", color: "#999" }}>
                          No passenger data
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </td>
            </tr>

            {/* ══════════════ FARE DETAILS ══════════════ */}
            <tr>
              <td style={{ padding: "0 20px 16px" }}>
                <table style={{ ...S.fareTable, width: "100%" }}>
                  <tbody>
                    <tr>
                      <td style={{ padding: "6px 8px" }}>
                        <strong style={{ fontSize: 15, color: "#1f91cd" }}>Fare Details</strong>
                      </td>
                      <td style={{ padding: "6px 8px" }} />
                      <td style={{ padding: "6px 8px", textAlign: "right" }}>
                        <strong style={{ fontSize: 15, color: "#1f91cd" }}>Amount (INR)</strong>
                      </td>
                    </tr>
                    <tr>
                      <td style={S.fareTd}>Basic Fare :</td>
                      <td style={S.fareTd} />
                      <td style={{ ...S.fareTd, textAlign: "right" }}>{aed(totalBaseFare)}</td>
                    </tr>
                    <tr>
                      <td style={S.fareTd}>Other Charges :</td>
                      <td style={S.fareTd} />
                      <td style={{ ...S.fareTd, textAlign: "right" }}>{aed(otherCharges)}</td>
                    </tr>
                    {fare0.PriceMeal > 0 && (
                      <tr>
                        <td style={S.fareTd}>Meal Charges :</td>
                        <td style={S.fareTd} />
                        <td style={{ ...S.fareTd, textAlign: "right" }}>{aed(fare0.PriceMeal)}</td>
                      </tr>
                    )}   
                    {fare0.PriceBaggage > 0 && (
                      <tr>
                        <td style={S.fareTd}>Baggage Charges :</td>
                        <td style={S.fareTd} />
                        <td style={{ ...S.fareTd, textAlign: "right" }}>{aed(fare0.PriceBaggage)}</td>
                      </tr>
                    )}
                    {fare0.PriceSeat > 0 && (
                      <tr>
                        <td style={S.fareTd}>Seat Charges :</td>
                        <td style={S.fareTd} />
                        <td style={{ ...S.fareTd, textAlign: "right" }}>{aed(fare0.PriceSeat)}</td>
                      </tr>
                    )}
                    <tr>
                      <td style={S.fareTd}>Discount :</td>
                      <td style={S.fareTd} />
                      <td style={{ ...S.fareTd, textAlign: "right" }}>{aed(totalDiscount)}</td>
                    </tr>
                    <tr>
                      <td colSpan={3} style={{ padding: 0 }}>
                        <hr style={{ borderColor: "#ccc", margin: "4px 0" }} />
                      </td>
                    </tr>
                    <tr>
                      <td style={{ ...S.fareTd, fontWeight: 700, fontSize: 14 }}>Total</td>
                      <td style={S.fareTd} />
                      <td style={{ ...S.fareTd, fontWeight: 700, fontSize: 14, textAlign: "right" }}>
                        {aed(grandTotal)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>

            {/* ══════════════ TERMS & CONDITIONS ══════════════ */}
            <tr>
              <td style={{ padding: "0 20px 20px", fontSize: 11, fontFamily: "Tahoma, Geneva, sans-serif", color: "#5f6061" }}>
                <strong>Terms &amp; Conditions</strong>
                <ul style={{ marginTop: 8, paddingLeft: 20 }}>
                  {[
                    "All passengers must produce a valid photo identification proof at the time of check in.",
                    "Guests will be subjected to a security screening prior to boarding the aircraft.",
                    "For Flights within India: Check-in counters open 3 hours prior to departure and close 1 hour prior.",
                    "For International flights: Check-in usually starts 3 hours prior; counters close 75 mins before departure.",
                    "Flight timings are subject to change without prior notice. Please recheck with the carrier.",
                    "For Fare Rules/Cancellation policy – refer to fare rules laid by the carrier.",
                  ].map((t, i) => (
                    <li key={i} style={{ marginBottom: 4 }}>{t}</li>
                  ))}
                </ul>
              </td>
            </tr>

          </tbody>
        </table>

        {/* ══════════════ ACTION BUTTONS (no print) ══════════════ */}
        <div style={S.actions} className="noPrint">
          <button style={S.btnBlue} onClick={() => window.print()}>🖨️ Print Ticket</button>

          {bookingStatus === 17 && (
            <button style={S.btnBlue} onClick={() => alert("Ticket Now - BookingId: " + (bookingData.BookingId || bookingId))}>
              Ticket Now
            </button>
          )}
          <button
            style={{ ...S.btnBlue, background: "#6c757d" }}
            onClick={() => navigate("/")}
          >
            🏠 Home
          </button>
        </div>

      </div>

    <style>{`
  @media print {
    .noPrint { display: none !important; }

    .ticket-page {
      background: #fff !important;
      padding: 0 !important;
      margin: 0 !important;
    }

    .ticket-printable {
      max-width: 100% !important;
      width: 100% !important;
      margin: 0 !important;
    }

    .ticket-printable * {
      font-size: 11px !important;
    }

    * {
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
      color-adjust: exact !important;
    }

    table, tr, td, th {
      page-break-inside: avoid;
    }

    .ticket-printable table {
      break-inside: avoid;
    }

    @page {
      size: A4;
      margin: 8mm;
    }
  }

  @keyframes spin { to { transform: rotate(360deg); } }
`}</style>
    </div>
  );
}

// ============================================================
// STYLES
// ============================================================
const S = {
  page: {
    minHeight: "100vh",
    background: "#e6f0ff",
    padding: "1.5rem 1rem",
    fontFamily: "Tahoma, Geneva, sans-serif",
  },
  printable: {
    maxWidth: 1100,
    margin: "0 auto",
  },
  outerTable: {
    border: "1px solid #d1d1d1",
    fontFamily: "Tahoma, Geneva, sans-serif",
    borderRadius: 4,
    background: "#fff",
    width: "100%",
    borderCollapse: "collapse",
  },

  // Status badges
  statusBadge: {
    display: "inline-block",
    padding: "3px 10px",
    borderRadius: 12,
    fontSize: 11,
    fontWeight: 600,
  },
  badgeGreen:  { background: "#dcfce7", color: "#15803d" },
  badgeRed:    { background: "#fee2e2", color: "#b91c1c" },
  badgeYellow: { background: "#fef9c3", color: "#a16207" },

  // Barcode placeholder
  barcodeBox: {
    display: "inline-block",
    padding: "8px 12px",
    border: "1px solid #eee",
    borderRadius: 4,
  },
  barcodeLines: {
    display: "flex",
    alignItems: "stretch",
    gap: 2,
    height: 60,
  },
  barcodeLine: {
    background: "#222",
    height: "100%",
    borderRadius: 1,
  },

  // Tables
  dataTable: {
    borderCollapse: "collapse",
    fontSize: 12,
    marginTop: 5,
  },
  th: {
    background: "#bedff1",
    border: "1px solid #111",
    padding: "6px 8px",
    fontWeight: 700,
    fontSize: 12,
    whiteSpace: "nowrap",
  },
  td: {
    border: "1px solid #111",
    padding: "6px 8px",
    fontSize: 12,
    verticalAlign: "middle",
  },

  // Airline circle icon (now holds the logo image or ✈ fallback)
  airlineCircle: {
    width: 32,
    height: 32,
    borderRadius: 6,
    background: "#eff6ff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 14,
    color: "#2563eb",
    flexShrink: 0,
    overflow: "hidden",
    position: "relative",
  },
  airlineLogo: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
  },
  airlineFallback: {
    width: "100%",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 14,
    color: "#2563eb",
  },
  airportCode: { fontWeight: 700, fontSize: 13 },

  // Passenger avatar
  avatar: {
    width: 26,
    height: 26,
    borderRadius: "50%",
    background: "#eff6ff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 11,
    fontWeight: 700,
    color: "#2563eb",
    flexShrink: 0,
  },

  // Fare table
  fareTable: {
    border: "1px solid #d1d1d1",
    borderCollapse: "collapse",
    fontSize: 12,
  },
  fareTd: {
    padding: "5px 8px",
    fontSize: 13,
  },

  // Actions
  actions: {
    display: "flex",
    gap: 10,
    justifyContent: "center",
    padding: "1rem 0",
  },
  btnBlue: {
    backgroundColor: "#007BFF",
    color: "#fff",
    border: "none",
    padding: "10px 20px",
    borderRadius: 4,
    cursor: "pointer",
    fontSize: 14,
    fontWeight: 600,
  },

 
  noDataBox: {
    maxWidth: 480,
    margin: "60px auto",
    background: "#fff",
    border: "1px solid #e5e7eb",
    borderRadius: 12,
    padding: "2rem",
    textAlign: "center",
  },
  h2: { fontSize: 20, fontWeight: 700, color: "#111827", margin: "8px 0" },
  muted: { fontSize: 14, color: "#6b7280" },
};